export default "__VITE_ASSET__BPw$WJqn__"